import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-addIcon",
  "use": "icon-addIcon-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-addIcon\"><path d=\"M8 2a1 1 0 0 1 1 1v4h4a1 1 0 1 1 0 2H9v4a1 1 0 1 1-2 0V8.999L3 9a1 1 0 0 1 0-2l4-.001V3a1 1 0 0 1 1-1Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol